<template>
  <v-container class="py-12">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Fornecedores</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn color="primary" elevation="0" to="/manutencoes/fornecedores/novo">
              <v-icon left small>mdi-plus</v-icon>
              Novo fornecedor
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Filtro -->
    <v-row>
      <v-col cols="12">
        <v-card class="filter-card">
          <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="load">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense outlined hide-details
                    label="Buscar por nome"
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Aplicar filtros</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabela -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :loading="loading"
            :footer-props="footerProps"
            no-data-text="Nenhum fornecedor cadastrado"
            loading-text="Carregando..."
            class="app-table hover-table"
          >
            <template v-slot:[`item.company_name`]="{ item }">
              <div class="font-weight-medium">{{ item.company_name }}</div>
              <div class="caption grey--text" v-if="item.email">{{ item.email }}</div>
            </template>
            <template v-slot:[`item.cnpj`]="{ item }">
              <span class="caption">{{ formatCnpj(item.cnpj) }}</span>
            </template>
            <template v-slot:[`item.address`]="{ item }">
              <div class="caption">
                {{ item.street }}{{ item.complement ? ', ' + item.complement : '' }}
              </div>
              <div class="caption grey--text">{{ item.city }} - {{ item.state }}</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="primary" v-bind="attrs" v-on="on" @click="$router.push('/manutencoes/fornecedores/' + item.id)">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="remove(item)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SupplierList',
  data: () => ({
    breadcrumbs: [
      { text: 'Home', to: '/home', disabled: false, exact: true },
      { text: 'Manutenções', disabled: false, to: '/manutencoes', exact: true },
      { text: 'Fornecedores', disabled: true, exact: true },
    ],
    headers: [
      { text: 'Fornecedor', value: 'company_name' },
      { text: 'CNPJ', value: 'cnpj' },
      { text: 'Telefone', value: 'phone_number' },
      { text: 'Endereço', value: 'address', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false, width: '100px' },
    ],
    footerProps: {
      itemsPerPageText: 'Itens por página:',
      itemsPerPageOptions: [10, 20, 50],
      pageText: '{0}-{1} de {2}',
    },
    states: [
      'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
      'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
      'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
    ],
    items: [],
    search: '',
    loading: false,
  }),
  computed: {
    filteredItems() {
      if (!this.search) return this.items
      const term = this.search.toLowerCase()
      return this.items.filter((i) =>
        (i.company_name || '').toLowerCase().includes(term) ||
        (i.cnpj || '').includes(term)
      )
    },
  },
  created() {
    this.load()
  },
  methods: {
    formatCnpj(cnpj) {
      if (!cnpj) return '-'
      const clean = cnpj.replace(/\D/g, '')
      if (clean.length !== 14) return cnpj
      return clean.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
    },
    notifyError(message) {
      if (this.$dialog?.notify) {
        this.$dialog.notify.error(message, { position: 'top-right', timeout: 5000 })
      }
    },
    notifySuccess(message) {
      if (this.$dialog?.notify) {
        this.$dialog.notify.success(message, { position: 'top-right', timeout: 4000 })
      }
    },
    async load() {
      this.loading = true
      try {
        const { data } = await axios.get('/api/suppliers')
        this.items = Array.isArray(data) ? data : []
      } catch (error) {
        this.notifyError(this.$codes ? this.$codes(error) : 'Erro ao carregar fornecedores.')
      } finally {
        this.loading = false
      }
    },
    async remove(item) {
      if (!window.confirm(`Deseja remover o fornecedor "${item.company_name}"?`)) return

      try {
        await axios.delete(`/api/suppliers/${item.id}`)
        this.notifySuccess('Fornecedor removido.')
        this.load()
      } catch (error) {
        this.notifyError(this.$codes ? this.$codes(error) : 'Erro ao remover fornecedor.')
      }
    },
  },
}
</script>
